import { render, staticRenderFns } from "./studentEdit.vue?vue&type=template&id=0078e0fa&"
import script from "./studentEdit.vue?vue&type=script&lang=js&"
export * from "./studentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports